import React, { useState } from 'react';
import { useForm, H2, PasswordResetEmail, OneTimePassword } from '/src/components';
import Login from './Login';
import * as styles from './styles.scss';

const LoginCustomer = ({
    login,
    requestPasswordResetEmail,
    onSuccess,
    hideModal,
    isLoading,
    translate,
    cloudflareSiteKey,
    requestPasswordOtp,
    loginOtp,
}) => {
    const [isReset, setIsReset] = useState(false);
    const [isOneTimePassword, setIsOneTimePassword] = useState(false);
    const { data, ...props } = useForm(
        {
            email: '',
            password: '',
        },
        {
            email: { isRequired: true },
            password: { isRequired: true },
        }
    );

    const handleOtp = () => setIsOneTimePassword(!isOneTimePassword);

    return (
        isOneTimePassword
        ?
            <OneTimePassword
                translate={translate}
                cloudflareSiteKey={cloudflareSiteKey}
                requestPasswordOtp={requestPasswordOtp}
                loginOtp={loginOtp}
                isLoading={isLoading}
                hideModal={hideModal}
                handleBack={() => setIsOneTimePassword(false)}
                email={data.email}
            />
        :
            <>
                <H2 className={isReset ? styles.reset : styles.title}>
                    {
                        isReset
                            ? translate('Please enter your email address below. You will receive a link to reset your password.')
                            : translate('Login into your account')
                    }
                </H2>
                {
                    isReset
                        ?
                        <PasswordResetEmail
                            email={data.email}
                            translate={translate}
                            isLoading={isLoading}
                            onSuccess={onSuccess}
                            requestPasswordResetEmail={requestPasswordResetEmail}
                            cloudflareSiteKey={cloudflareSiteKey}
                        />
                        :
                        <Login
                            login={login}
                            hideModal={hideModal}
                            isLoading={isLoading}
                            translate={translate}
                            cloudflareSiteKey={cloudflareSiteKey}
                            data={data}
                            handleOtp={handleOtp}
                            requestPasswordOtp={requestPasswordOtp}
                            {...props}
                        />
                }
                <div className={styles.forgot}>
                    <button
                        onClick={() => setIsReset(!isReset)}
                        disabled={isLoading}
                    >
                        {isReset ? translate('Back to login') : translate('Forgot password')}
                    </button>
                </div>
            </>
    );
};

export default LoginCustomer;
